// src/hooks/useClientFetcher.tsx
/* Hook encargado de hacer la consulta a la base y 
traer el cliente a partir de su id

Autor: Benjamín León
Fecha: 2024-08-16
*/
import { useState } from 'react'

import Client from '../interfaces/Client.ts'
import { customFetch } from '../utils/customFetch.ts'

import { makeUrlClient, makeUrlClientDocs } from './connectionData.tsx'

const useClientFetcher = () => {
  const [error, setError] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchClient = async (id: string) => {
    setLoading(true)

    try {
      const data = await fetchDatabase(id)
      setError(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setError(err)
      } else {
        setError(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const fetchDatabase = async (id: string): Promise<Client> => {
    const apiUrl = makeUrlClient(id)

    // Fetching documents from the collection and converting them into an array
    const response = await fetch(apiUrl)

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`)
    }

    const client: Client = await response.json()

    return client
  }
  const fetchClientDocs = async (id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlClientDocs(id)
      const client = await customFetch<Client>(apiUrl)
      setError(null)

      return client
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setError(err)
      } else {
        setError(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorClient: error, loading, fetchClient, fetchClientDocs }
}

export default useClientFetcher
